import { render, staticRenderFns } from "./a-breadcrumb-item.vue?vue&type=template&id=0bb163b1&scoped=true&lang=pug"
import script from "./a-breadcrumb-item.vue?vue&type=script&lang=js"
export * from "./a-breadcrumb-item.vue?vue&type=script&lang=js"
import style0 from "./a-breadcrumb-item.vue?vue&type=style&index=0&id=0bb163b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb163b1",
  null
  
)

export default component.exports